module.exports = __webpack_public_path__ + "static/img/empty-pay-default.43c8d7ec.png";